var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{staticClass:"ml-auto mr-4 mt-2",attrs:{"id":"back-button","size":"medium"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" Tilbage ")])}
var staticRenderFns = []

export { render, staticRenderFns }